/**
 * Build-time flags for the UI style. Kept apart from uiStyle.ts and UiStyleContext so jest
 * (ts-jest CommonJS cannot parse `import.meta`) can mock it.
 */

/** VITE_UI_STYLE: cosmos | arcade | daylight | luxe | dusk (anything else means Dusk, DEFAULT_UI_STYLE). */
export function buildUiStyle(): string | undefined {
  return import.meta.env.VITE_UI_STYLE;
}

/**
 * Dev, or a build with VITE_UI_STYLE_SWITCHER=true. A constant expression of build-time values, so
 * a build without the switcher folds it to false and drops what it gates (App.tsx: the switcher
 * chunk).
 */
export const STYLE_SWITCHER_BUILD: boolean = import.meta.env.DEV === true || import.meta.env.VITE_UI_STYLE_SWITCHER === 'true';

/** The preview switcher and `?style=` work only in dev or a build with VITE_UI_STYLE_SWITCHER=true. */
export function isStyleSwitcherAllowed(): boolean {
  return STYLE_SWITCHER_BUILD;
}
